(function () {
  angular.module("akitabox.ui.dialogs.request.reopen", [
    "akitabox.core.constants",
    "akitabox.core.services.request",
    "akitabox.core.toast",
  ]);
})();
